/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMaterialDto } from '../../models/backend-material-dto';
import { BackendMaterialRequestDto } from '../../models/backend-material-request-dto';

export interface OpexesMaterialsUpdate$Params {
  id: number;
  body: BackendMaterialRequestDto;
}

export function opexesMaterialsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesMaterialsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMaterialDto>> {
  const rb = new RequestBuilder(rootUrl, opexesMaterialsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMaterialDto>;
    }),
  );
}

opexesMaterialsUpdate.PATH = '/api/opexes/materials/{id}/';
